import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore, writeBatch } from "firebase/firestore" // ✅ Added writeBatch import
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCfhYYV3qs0MkHqDiCT0WohE39X0E9itRY",
  authDomain: "civil-neighbr.firebaseapp.com",
  projectId: "civil-neighbr",
  storageBucket: "civil-neighbr.firebasestorage.app",
  messagingSenderId: "113333327414",
  appId: "1:113333327414:web:6571393dcde19d987caa97",
  measurementId: "G-XWZ2N8PHCP"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Export initialized services
const auth = getAuth(app)
const db = getFirestore(app)
const storage = getStorage(app)

export { auth, db, storage, writeBatch }